import template from './modal.html';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

/* @ngInject */
export function confirmModal (goModalBootstrap) {

	function open (options) {
		options.template = template;
		options.controller = function () {};
		options.windowClass = options.name = 'confirm-modal';
		options.backdrop = 'static';
		options.controllerAs = '$ctrl';
		options.bindToController = true;
		options.goreact = true; // For new modal styles
		options.modalData = {
			...(options.modalData ?? {}),
			dialogTitleId: options.modalData?.title == null
				? options.modalData?.dialogTitleId
				: options.modalData?.dialogTitleId ?? `confirm-modal-title-${UniqueIdGeneratorUtil.getId()}`
		};

		return goModalBootstrap.open(options);
	}

	return {
		open
	};
}
